import fslightbox from 'fslightbox';
import '@modules/GallerySlider';

import '@dev/scss/templates/text.scss';
